import axios, { type AxiosError } from 'axios'
import { useAuthStore } from '@/store/auth'

export const api = axios.create({
  baseURL: '/api/v1',
  timeout: 15_000,
  withCredentials: true,  // нужно для HttpOnly refresh cookie
})

// Добавляем Bearer token к каждому запросу
api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

let refreshing = false
let refreshQueue: Array<(ok: boolean) => void> = []

// Обрабатываем 401 — пробуем обновить access token через refresh cookie
api.interceptors.response.use(
  (res) => res,
  async (error: AxiosError) => {
    const original = error.config as typeof error.config & { _retry?: boolean }
    if (error.response?.status !== 401 || original?._retry) {
      return Promise.reject(error)
    }
    original._retry = true

    if (refreshing) {
      // Ждём пока уже идущий refresh завершится
      return new Promise((resolve, reject) => {
        refreshQueue.push((ok) => {
          if (ok) resolve(api.request(original!))
          else reject(error)
        })
      })
    }

    refreshing = true
    try {
      const { data } = await axios.post('/api/v1/auth/refresh', {}, { withCredentials: true })
      useAuthStore.getState().setToken(data.access_token)
      refreshQueue.forEach((cb) => cb(true))
      refreshQueue = []
      return api.request(original!)
    } catch {
      refreshQueue.forEach((cb) => cb(false))
      refreshQueue = []
      useAuthStore.getState().logout()
      window.location.assign('/login')
      return Promise.reject(error)
    } finally {
      refreshing = false
    }
  },
)
